import React from "react";
import Modal from "react-native-modal";
import ResponsiveContent from "../shared/responsive-content";
import { View, Pressable, Text } from "react-native";
import CloseIcon from "@/assets/svgs/close-icon";
import { Button } from "../ui/button";

function NoShowReportedModal({
  isVisible,
  onClose,
  onDismiss,
}: {
  isVisible: boolean;
  onClose: () => void;
  onDismiss: () => void;
}) {
  return (
    <Modal
      animationIn="slideInUp"
      animationOut="slideOutDown"
      isVisible={isVisible}
      onBackdropPress={onClose}
      onDismiss={() => {
        onDismiss();
      }}
      useNativeDriver
      useNativeDriverForBackdrop
      hideModalContentWhileAnimating
    >
      <ResponsiveContent>
        <View className="mx-4 bg-teachLoop-creamBase rounded-xl px-8 py-10">
          <View className="items-end">
            <Pressable
              onPress={onClose}
              className="active:opacity-80"
              style={{ marginHorizontal: -12 }}
            >
              <CloseIcon
                pathClassName="stroke-teachLoop-textPrimary"
                className="size-6"
              />
            </Pressable>
          </View>
          <View className="gap-8">
            <View className="items-center gap-4">
              <Text className="font-zilla-slab-medium font-medium text-[28px] leading-[1.2] text-black text-center">
                Your report has been submitted.
              </Text>
              <Text className="text-base font-geologica-regular font-normal leading-[1.5] text-teachLoop-textPrimary text-center">
                We&apos;ll review & update you shortly.
              </Text>
            </View>
            <Button fullWidth size="md" intent="primary" onPress={onClose}>
              <Button.Text size="md">Back to home</Button.Text>
            </Button>
          </View>
          <View className="h-3" />
        </View>
      </ResponsiveContent>
    </Modal>
  );
}

export default NoShowReportedModal;
